<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Dashboard Overview" subTitle="RayaCheck Admin" />

    <div class="row">
      <div class="col-lg-3 col-sm-6">
        <div class="card bg-white border-0 rounded-3 mb-4">
          <div class="card-body p-4 text-center">
            <div class="d-flex justify-content-center align-items-center bg-primary-transparent rounded-circle mx-auto mb-3" style="width: 60px; height: 60px;">
              <i class="material-symbols-outlined fs-24 text-primary">group</i>
            </div>
            <h3 class="fs-24 fw-bold mb-1">{{ stats.customers }}</h3>
            <span class="fs-14 text-secondary">Total Customers</span>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3 col-sm-6">
        <div class="card bg-white border-0 rounded-3 mb-4">
          <div class="card-body p-4 text-center">
            <div class="d-flex justify-content-center align-items-center bg-success-transparent rounded-circle mx-auto mb-3" style="width: 60px; height: 60px;">
              <i class="material-symbols-outlined fs-24 text-success">shopping_cart</i>
            </div>
            <h3 class="fs-24 fw-bold mb-1">{{ stats.orders }}</h3>
            <span class="fs-14 text-secondary">Total Orders</span>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3 col-sm-6">
        <div class="card bg-white border-0 rounded-3 mb-4">
          <div class="card-body p-4 text-center">
            <div class="d-flex justify-content-center align-items-center bg-warning-transparent rounded-circle mx-auto mb-3" style="width: 60px; height: 60px;">
              <i class="material-symbols-outlined fs-24 text-warning">build</i>
            </div>
            <h3 class="fs-24 fw-bold mb-1">{{ stats.services }}</h3>
            <span class="fs-14 text-secondary">Active Services</span>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3 col-sm-6" v-if="isQc">
        <div class="card bg-white border-0 rounded-3 mb-4">
          <div class="card-body p-4 text-center">
            <div class="d-flex justify-content-center align-items-center bg-danger-transparent rounded-circle mx-auto mb-3" style="width: 60px; height: 60px;">
              <i class="material-symbols-outlined fs-24 text-danger">verified</i>
            </div>
            <h3 class="fs-24 fw-bold mb-1">{{ stats.pendingQc }}</h3>
            <span class="fs-14 text-secondary">Antrean QC</span>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3 col-sm-6" v-else>
        <div class="card bg-white border-0 rounded-3 mb-4">
          <div class="card-body p-4 text-center">
            <div class="d-flex justify-content-center align-items-center bg-danger-transparent rounded-circle mx-auto mb-3" style="width: 60px; height: 60px;">
              <i class="material-symbols-outlined fs-24 text-danger">payments</i>
            </div>
            <h3 class="fs-24 fw-bold mb-1">{{ stats.payments }}</h3>
            <span class="fs-14 text-secondary">Payments</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue';
import PageTitle from '@/components/Common/PageTitle.vue';
import customerService from '@/services/customerService';
import orderService from '@/services/orderService';
import serviceService from '@/services/serviceService';
import paymentService from '@/services/paymentService';

export default defineComponent({
  name: 'DashboardPage',
  components: {
    PageTitle
  },
  setup() {
    const isQc = computed(() => {
      const userStr = localStorage.getItem('user');
      if (!userStr) return false;
      try {
        const user = JSON.parse(userStr);
        return user.role === 'qc';
      } catch (e) {
        return false;
      }
    });

    const stats = ref({
      customers: 0,
      orders: 0,
      services: 0,
      payments: 0,
      pendingQc: 0,
    });

    onMounted(async () => {
      try {
        const promises: Promise<any>[] = [
          customerService.getAll(),
          orderService.getAll(),
          serviceService.getAll(),
        ];
        if (!isQc.value) {
          promises.push(paymentService.getAll());
        }

        const results = await Promise.all(promises);
        const custRes = results[0];
        const ordRes = results[1];
        const servRes = results[2];
        const payRes = !isQc.value ? results[3] : null;

        stats.value.customers = custRes.data?.length || 0;
        stats.value.orders = ordRes.data?.length || 0;
        stats.value.services = servRes.data?.length || 0;
        if (payRes) {
          stats.value.payments = payRes.data?.length || 0;
        }

        if (Array.isArray(ordRes.data)) {
          stats.value.pendingQc = ordRes.data.filter((o: any) =>
            o.qc_status === 'SUBMITTED_TO_QC' || (!o.qc_status && o.order_status === 'IN_PROGRESS')
          ).length;
        }
      } catch (error) {
        console.error("Error fetching dashboard stats", error);
      }
    });

    return {
      stats,
      isQc,
    };
  }
});
</script>
